import { ContactSectionContentProps } from '../components/organisms/Contact/types';

const contact: ContactSectionContentProps = {
  email: 'akdevjs@gmail.com',
  socials: {
    linkedIn: 'https://www.linkedin.com/in/akdevjs/',
    github: 'https://github.com/akdevjs',
    instagram: 'https://www.instagram.com/akdevjs',
  },
};

export default contact;
